module.exports = __webpack_public_path__ + "static/media/What The Truck_Screenshot.7293e1ee.webp";